import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "location",
  "use": "location-usage",
  "viewBox": "0 0 133.8 194.61",
  "content": "<symbol viewBox=\"0 0 133.8 194.61\" id=\"location\"><defs></defs><title>资源 3</title><g id=\"location_图层_2\" data-name=\"图层 2\"><g id=\"location_图层_1-2\" data-name=\"图层 1\"><path d=\"M66.48,194.61S0,109.1,0,72.61C0,.76,66.48,0,66.48,0S133.8.75,133.8,72.23c0,37.62-67.32,122.38-67.32,122.38ZM67.24,42A25.28,25.28,0,1,0,92.52,67.25,25.27,25.27,0,0,0,67.24,42Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/location.svg
// module id = C5qe
// module chunks = 264